import { memo, useState } from 'react'

import { Box } from '@mui/material'

import { ConfigEditor } from './ConfigEditor'
import { JSONConfig } from './JSONConfig'
import { ViewMode, ViewModeToggle } from './ViewModeToggle'

/** Config tab: Simple structured editor ⇄ raw JSON editor. Both edit the one config. */
const ConfigRaw = () => {
  const [mode, setMode] = useState<ViewMode>('simple')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box sx={{ px: 3, pt: 2, pb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <ViewModeToggle mode={mode} onChange={setMode} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>{mode === 'simple' ? <ConfigEditor /> : <JSONConfig />}</Box>
    </Box>
  )
}

export const Config = memo(ConfigRaw)
